// Copyright (c) 2017 Deere & Company

import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import t from 'tcomb';

const Territories = t.list(DealerHierarchyTerritory, 'Territories');

export const getDefaultState = () => new Territories([]);

export default Territories;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/state/territories.js